import { render, staticRenderFns } from "./IssueLabel.vue?vue&type=template&id=64473c80&"
import script from "./IssueLabel.vue?vue&type=script&lang=js&"
export * from "./IssueLabel.vue?vue&type=script&lang=js&"
import style0 from "./IssueLabel.vue?vue&type=style&index=0&id=64473c80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports